import { render, staticRenderFns } from "./InputCheckboxTC.vue?vue&type=template&id=9f2a8926&scoped=true"
import script from "./InputCheckboxTC.vue?vue&type=script&lang=js"
export * from "./InputCheckboxTC.vue?vue&type=script&lang=js"
import style0 from "./InputCheckboxTC.vue?vue&type=style&index=0&id=9f2a8926&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2a8926",
  null
  
)

export default component.exports